export const ACHIEVEMENT_BADGE_COLORS = {
	default: 'default',
	gold: 'gold',
	silver: 'silver',
	bronze: 'bronze',
	purple: 'purple',
	monochrome: 'monochrome'
};
